module.exports = __webpack_public_path__ + "static/media/logo_pvcombank.4eca233e.svg";